import XTNA from './XTNA';
import XTNAChart from './Chart.jsx';
import XTNAForm from './Form.jsx';
import XTNAResults from './Results.jsx';

export default {
  XTNA,
  XTNAChart,
  XTNAForm,
  XTNAResults
};



// WEBPACK FOOTER //
// ./src/App/xtna/index.js